import React, { useEffect, useState } from 'react';
import { CheckIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const interval = setInterval(() => {
      const difference = targetTime - new Date().getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const handlePurchase = () => {
    window.location.href = 'https://checkout.ebookpoint.shop/cart/59617073561681:1';
  };
  const includes = ['📚 7 Capítulos completos paso a paso', '🎁 Bono 1: Checklist Profesional de Entrega', '📄 Bono 2: Plantilla de Orden de Trabajo (editable)', '🧪 Bono 3: Tabla Visual de Materiales Dentales', '💰 Bono 4: Calculadora de Precios para Técnicos', '🗺️ Bono 5: Hoja de Ruta del Acrílico al CAD/CAM', '🗂️ Plantillas editables listas para imprimir', '⚡ Acceso inmediato y de por vida (100% PDF)'];
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="bg-gray-900 text-white rounded-lg px-3 py-2 min-w-[60px] text-center" data-id="element-127">
      <div className="text-2xl font-bold tabular-nums" data-id="element-128">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-[10px] tracking-wider text-gray-300" data-id="element-129">{label}</div>
    </div>;
  return <section id="comprar" className="w-full px-4 py-16 bg-gray-50" data-id="element-130">
      <div className="max-w-2xl mx-auto" data-id="element-131">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-132">
          {/* Urgency header */}
          <div className="bg-green-600 text-white px-6 py-5 text-center" data-id="element-133">
            <div className="inline-flex items-center gap-2 text-sm font-medium mb-3" data-id="element-134">
              <ClockIcon className="w-4 h-4" data-id="element-135" />
              <span data-id="element-136">La oferta termina en</span>
            </div>
            <div className="flex justify-center gap-2" data-id="element-137">
              <TimeBox value={timeLeft.hours} label="HORAS" data-id="element-138" />
              <TimeBox value={timeLeft.minutes} label="MIN" data-id="element-139" />
              <TimeBox value={timeLeft.seconds} label="SEG" data-id="element-140" />
            </div>
          </div>

          <div className="p-6 md:p-8" data-id="element-141">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 text-center mb-1" data-id="element-142">
              Todo lo que te llevás hoy
            </h2>
            <p className="text-center text-sm text-green-600 font-semibold mb-6" data-id="element-143">
              Por el mismo precio, sin costos extra
            </p>

            {/* Bonus images */}
            <div className="grid grid-cols-3 gap-3 mb-6" data-id="element-144">
              {['https://cdn.magicpatterns.com/uploads/68Gi7YjjFmyiwobydfqPif/Screenshot_2026-06-05_at_11.19.24_PM.png', 'https://cdn.magicpatterns.com/uploads/gWQF9QRLC75K3dN6GXeM7Y/Screenshot_2026-06-05_at_11.19.05_PM.png', 'https://cdn.magicpatterns.com/uploads/9KSKqZiWi61d83mGfJGyBN/Screenshot_2026-06-05_at_11.18.42_PM.png'].map((src, i) => <img key={i} src={src} alt={`Bono ${i + 1}`} className="w-full rounded-lg shadow-sm border border-gray-100" data-id="element-145" />)}
            </div>

            {/* Itemized list */}
            <ul className="space-y-2.5 mb-7" data-id="element-146">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-2.5" data-id="element-147">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-148" />
                  <span className="text-sm md:text-base text-gray-800" data-id="element-149">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="bg-green-50 rounded-2xl p-5 text-center mb-5" data-id="element-150">
              <p className="text-gray-400 line-through text-lg mb-1" data-id="element-151">
                Antes $55.900
              </p>
              <p className="text-5xl font-extrabold text-green-600 mb-1" data-id="element-152">
                $19.990
              </p>
              <p className="text-xs text-gray-600" data-id="element-153">
                Pago único · Acceso de por vida
              </p>
            </div>

            <button onClick={handlePurchase} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-5 px-8 rounded-xl text-lg md:text-xl transition-colors duration-200 shadow-lg hover:shadow-xl mb-4" data-id="element-154">
              Quiero dominar el laboratorio
            </button>

            <div className="flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-155">
              <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-156" />
              <span data-id="element-157">Compra 100% segura · Acceso inmediato tras el pago</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}